import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoginService } from '../../core/services/login.service';
import { fromRoot } from '../../core/utilities/ngrx-loader.utility';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private readonly loaderStore: Store<{ loader: number }>,
    private readonly router: Router,
  ) {

  }

  ngOnInit() {
    this.loaderStore.dispatch(fromRoot.addLoader()());
    if(this.loginService.isUserAuthenticated().success && this.loginService.isBackendTokenExists()){
      this.router.navigate(['/workspace', 'solutions']);
    }
  }

}